import React from 'react';
import './PrivacyPage.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-page">
      <h1>PokerBuddy Privacy Policy</h1>
      <p>Last updated: [Date, e.g., October 26, 2023]</p>

      <h2>1. Introduction</h2>
      <p>Welcome to PokerBuddy! We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-powered poker coaching application (the "Service").</p>

      <h2>2. Information We Collect</h2>
      <h3>2.1 Personal Information</h3>
      <p>When you register or log in, primarily through social logins (like Discord via Auth0), we may collect personal information such as:</p>
      <ul>
        <li>Your name or username</li>
        <li>Email address</li>
        <li>Profile picture (if provided by the login service)</li>
        <li>Unique identifiers associated with your social login</li>
      </ul>

      <h3>2.2 Usage and Technical Data</h3>
      <p>We collect information related to your interaction with the Service, including:</p>
      <ul>
        <li>Poker hand histories you submit for analysis.</li>
        <li>Analysis results and feedback generated by our AI.</li>
        <li>Your interactions with features like the simulator, charts, and equity calculator.</li>
        <li>Game progress, statistics, and experience points (XP).</li>
        <li>Device information, IP address, browser type, and operating system for technical support and service improvement.</li>
        <li>Anonymized usage patterns to understand how the Service is used.</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide, operate, and maintain the PokerBuddy Service.</li>
        <li>Analyze your submitted hand histories and provide AI-driven feedback and strategy insights.</li>
        <li>Personalize your experience and track your progress.</li>
        <li>Improve the accuracy and effectiveness of our AI models and the overall Service.</li>
        <li>Authenticate your account and manage your session.</li>
        <li>Save your preferences and settings.</li>
        <li>Communicate with you, including sending service-related notifications (with your consent where required).</li>
        <li>Ensure the security and integrity of our Service and prevent abuse.</li>
      </ul>

      <h2>4. Cookies and Local Storage</h2>
      <p>We use cookies and browser local storage to enhance your experience. These technologies are used for:</p>
      <ul>
        <li>Maintaining your login session.</li>
        <li>Storing preferences and settings.</li>
        <li>Temporarily storing data related to your current activity (e.g., hand analysis inputs).</li>
      </ul>
      <p>You can manage cookies through your browser settings, but disabling them may affect the functionality of the Service.</p>

      <h2>5. Data Security</h2>
      <p>We implement reasonable technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission or electronic storage is 100% secure.</p>

      <h2>6. Third-Party Services</h2>
      <p>We use third-party services like Auth0 for authentication and potentially cloud hosting providers (e.g., AWS). These services have their own privacy policies, and we encourage you to review them. We share only the necessary information with these providers to enable their services.</p>

      <h2>7. Children's Privacy</h2>
      <p>Our Service is not intended for individuals under the age of 18 (or the legal age required to gamble in your jurisdiction, if higher). We do not knowingly collect personal information from children or those under the legal age.</p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page and updating the "Last updated" date.</p>

      <h2>9. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at: contact@pokerbuddy.io</p>
    </div>
  );
};

export default PrivacyPolicy;